import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import TabbedPortlet from '../../../../commonComponents/portlets/Tabbed/TabbedPortlet';
import NewsFilters from './NewsFilters';
import NewsSectionTab from './NewsSectionTab';

const BASE_URL = '/dashboard/list';

function NewsSection({ t }) {
  const [url, setUrl] = useState(BASE_URL);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleTabChange = useCallback(index => {
    setSelectedIndex(index);
    if (index === 0) {
      setUrl(BASE_URL);
    } else {
      setUrl(`${BASE_URL}?type=drive`);
    }
  }, []);

  const tabs = [
    {
      id: 'inboxTab',
      title: t('inbox_news'),
      content: <NewsSectionTab url={url} />,
    },
    {
      id: 'driveTab',
      title: t('inbox_drive'),
      content: <NewsSectionTab url={`${BASE_URL}?type=drive`} />,
    },
  ];

  return (
    <TabbedPortlet
      id="news-section"
      tabs={tabs}
      selectedIndex={selectedIndex}
      onTabChange={handleTabChange}
      actions={
        selectedIndex === 0 && (
          <NewsFilters
            onChange={filter => setUrl(`${BASE_URL}?type=${filter}`)}
          />
        )
      }
    />
  );
}

NewsSection.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(NewsSection);
